module.exports = "No matching products, try another search.\n"


//////////////////
// WEBPACK FOOTER
// ./storybook/app/utils/no-results.html
// module id = 695
// module chunks = 0